import { cn } from "../../../lib/cn";
import { Pressable } from "../../Pressable";
import { Paragraph } from "../../typography/Paragraph";
import { useMessage } from "./Context";

export function MessageReply() {
    const { reply } = useMessage();

    if (!reply) {
        return null;
    }

    return (
        <Pressable className="block w-full min-w-0 text-left" onPress={reply.onPress}>
            <div
                id={`chat-message-reply-${reply.id}`}
                aria-busy={reply.isPending}
                className={cn(
                    "-m-8 flex w-[calc(100%+theme(spacing.16))] max-w-none flex-row items-start gap-16 rounded-[8px] bg-background-chat p-8",
                    reply.isPending && "animate-pulse",
                )}
            >
                {reply.imageUrl ? (
                    <img
                        src={reply.imageUrl}
                        alt={reply.message}
                        className="size-48 max-h-48 min-h-48 min-w-48 max-w-48 object-cover"
                    />
                ) : null}

                <div className="flex min-w-0 flex-1 flex-col items-start gap-4">
                    <Paragraph size="small" weight="bold">
                        {reply.title}
                    </Paragraph>

                    <Paragraph
                        size="xsmall"
                        color="secondary"
                        className="line-clamp-2 max-h-64 overflow-hidden text-ellipsis"
                    >
                        {reply.message}
                    </Paragraph>
                </div>
            </div>
        </Pressable>
    );
}
